// src/components/HiddenSubmissionsDataGrid.jsx

import * as React from 'react';
import PropTypes from 'prop-types';
import { DataGridPremium  } from '@mui/x-data-grid-premium';
import { Button, Box, Stack, createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import { submissionColumns, reviewColumns } from './HiddenSubmissionsDataGridColumns';

const darkGridTheme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        default: '#000',    // grid container background
        paper: '#1e1e1e',    // inner surfaces
      },
    },
    components: {
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: 'none',
            backgroundColor: '#121212',
          },
          columnHeaders: {
            backgroundColor: '#1e1e1e',
          },
        },
      },
    },
  });

export default function HiddenSubmissionsDataGrid({
  allSubmissions,
  onCellUpdate,
  submissionToken,
  reviewingTokens,
  onClose,
}) {
  const [selectionModel, setSelectionModel] = React.useState([]);
  const [viewType, setViewType] = React.useState('submissions');

  const hiddenSubmissions = allSubmissions.filter(
    (s) => s.hidden && s.formToken === submissionToken
  );
  const hiddenReviews = allSubmissions.filter(
    (s) => s.hidden && reviewingTokens.includes(s.formToken)
  );

  const rows = viewType === 'submissions' ? hiddenSubmissions : hiddenReviews;
  const columns =
    viewType === 'submissions'
      ? submissionColumns
      : reviewColumns(allSubmissions);

  const handleUnhide = () => {
    selectionModel.forEach((id) => onCellUpdate(id, false, 'hidden'));
    setSelectionModel([]);
  };

  return (
    <ThemeProvider theme={darkGridTheme}>
      <CssBaseline />
      <Box sx={{ p: 2, backgroundColor: 'background.default' }}>
        <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
          <Button
            variant="outlined"
            onClick={() =>
                setViewType((v) =>
                v === 'submissions' ? 'reviews' : 'submissions'
                )
            }
            >
            Show {viewType === 'submissions' ? 'Reviews' : 'Submissions'}
          </Button>
          <Button
            variant="contained"
            onClick={handleUnhide}
            disabled={!selectionModel.length}
          >
            Unhide Selected
          </Button>
          <Box sx={{ flexGrow: 1 }} />
          <Button variant="text" onClick={onClose}>
            Close
          </Button>
        </Stack>

        <div style={{ width: '100%', height: 500 }}>
            <DataGridPremium
            rows={rows}
            columns={columns}
            getRowId={(row) => row.id}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            checkboxSelection
            rowSelectionModel={selectionModel}
            onRowSelectionModelChange={setSelectionModel}
            onCellEditCommit={({ id, field, value }) =>
                onCellUpdate(id, value, field)
            }
            />
        </div>
    </Box>
    </ThemeProvider>
  );
}

HiddenSubmissionsDataGrid.propTypes = {
  allSubmissions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onCellUpdate: PropTypes.func.isRequired,
  submissionToken: PropTypes.string.isRequired,
  reviewingTokens: PropTypes.arrayOf(PropTypes.string).isRequired,
  onClose: PropTypes.func.isRequired,
};
